import { gql } from '@apollo/client';

export const ADD_PAYMENT_METHOD_MUTATION = gql`
  mutation addPaymentMethodMutation($paths: PaymentPaths!) {
    addPaymentMethod(paths: $paths) {
      __typename
      ... on SetupSessionStripe {
        sessionId
        publishableKey
      }
      ... on SetupSessionPayex {
        redirectUrl
      }
    }
  }
`;

export const REMOVE_PAYMENT_METHOD_MUTATION = gql`
  mutation removePaymentMethodMutation {
    removePaymentMethod {
      __typename
    }
  }
`;
